/**
 * Eira Theme — Localization Form
 * Custom element that handles language + country/currency selector disclosure.
 * - Opens/closes dropdowns on click
 * - Submits the Shopify localization form on option selection
 * - Closes on Escape or outside click
 */

(function () {
  'use strict';

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this._openGroup = null;
    }

    connectedCallback() {
      this.addEventListener('click', this._handleClick.bind(this));
      document.addEventListener('click', this._handleOutsideClick.bind(this));
      document.addEventListener('keydown', this._handleEscape.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._handleOutsideClick.bind(this));
      document.removeEventListener('keydown', this._handleEscape.bind(this));
    }

    _handleClick(e) {
      /* ── Trigger button clicked → toggle dropdown ── */
      var trigger = e.target.closest('.bc-localization__trigger');
      if (trigger) {
        e.preventDefault();
        var group = trigger.closest('.bc-localization__group');
        var list = group ? group.querySelector('.bc-localization__list') : null;
        if (!list) return;

        var isOpen = !list.hidden;
        this._closeAll();

        if (!isOpen) {
          list.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          this._openGroup = group;

          /* Scroll active item into view */
          var active = list.querySelector('.is-active');
          if (active) active.scrollIntoView({ block: 'nearest' });
        }
        return;
      }

      /* ── Option link clicked → submit form ── */
      var optionLink = e.target.closest('.bc-localization__option-link');
      if (optionLink) {
        e.preventDefault();
        var value = optionLink.dataset.value;
        if (!value) return;

        var group2 = optionLink.closest('.bc-localization__group');
        if (!group2) return;

        /* Determine if this is language or country */
        var langInput = group2.querySelector('input[name="language_code"]');
        var countryInput = group2.querySelector('input[name="country_code"]');

        if (langInput) {
          langInput.value = value;
        } else if (countryInput) {
          countryInput.value = value;
        }

        /* Submit the form */
        var form = group2.closest('form');
        if (form) form.submit();
      }
    }

    _handleOutsideClick(e) {
      if (!this.contains(e.target)) {
        this._closeAll();
      }
    }

    _handleEscape(e) {
      if (e.key === 'Escape') {
        this._closeAll();
      }
    }

    _closeAll() {
      var lists = this.querySelectorAll('.bc-localization__list');
      lists.forEach(function (list) {
        list.hidden = true;
      });
      var triggers = this.querySelectorAll('.bc-localization__trigger');
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      this._openGroup = null;
    }
  }

  customElements.define('localization-form', LocalizationForm);
})();
